import React from "react";
import { Typography, RaiseColors, Icon } from "componentLibrary";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = function Pagination(_ref) {
  var data = _ref.data,
    itemsPerPage = _ref.itemsPerPage,
    onChangePage = _ref.onChangePage,
    currentPage = _ref.currentPage,
    setCurrentPage = _ref.setCurrentPage;
  var totalItems = data.length;
  var totalPages = Math.ceil(totalItems / itemsPerPage);
  var hasPrev = currentPage > 1;
  var hasNext = currentPage < totalPages;
  var handlePrevPage = function handlePrevPage() {
    var nextPage = currentPage - 1;
    if (hasPrev) {
      setCurrentPage(currentPage - 1);
      onChangePage(nextPage);
    }
  };
  var handleNextPage = function handleNextPage() {
    var nextPage = currentPage + 1;
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      onChangePage(nextPage);
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "end",
      height: 64,
      padding: 16
    },
    children: [/*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        padding: 8,
        cursor: hasPrev ? "pointer" : undefined
      },
      onClick: handlePrevPage,
      children: [/*#__PURE__*/_jsx(Icon, {
        fontSize: 14,
        className: "fa-light fa-chevron-left",
        color: hasPrev ? RaiseColors.midnight : RaiseColors.neutral500
      }), /*#__PURE__*/_jsx(Typography, {
        color: hasPrev ? RaiseColors.midnight : RaiseColors.neutral500,
        variant: "paragraph_small",
        weight: "regular",
        style: {
          marginLeft: 8
        },
        children: "Prev"
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center"
      },
      children: [/*#__PURE__*/_jsx(Typography, {
        style: {
          padding: "8px 14px",
          backgroundColor: RaiseColors.neutral200
        },
        children: currentPage
      }), /*#__PURE__*/_jsxs(Typography, {
        children: [" of ", totalPages]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      style: {
        display: "flex",
        alignItems: "center",
        padding: 8,
        cursor: hasNext ? "pointer" : undefined
      },
      onClick: handleNextPage,
      children: [/*#__PURE__*/_jsx(Typography, {
        color: hasNext ? RaiseColors.midnight : RaiseColors.neutral500,
        variant: "paragraph_small",
        weight: "regular",
        style: {
          marginRight: 8
        },
        children: "Next"
      }), /*#__PURE__*/_jsx(Icon, {
        fontSize: 14,
        className: "fa-light fa-chevron-right",
        color: hasNext ? RaiseColors.midnight : RaiseColors.neutral500
      })]
    })]
  });
};
export default Pagination;